import { initModule } from 'Services/initModule.js';

export default {
    '/forms/visible-fields-config': {
        as: 'formsVisibleFieldsConfig',
        uses() {
            import(
                /* webpackChunkName: "formsvisiblefieldsconfig" */ '../../Forms/FormsVisibleConfig/FormsVisibleConfigController'
            ).then(module => initModule(module.default));
        },
    },
};
